function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 384 384",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D3F5FF"
    },
    d: "M52,16c0-6.8,5.2-12,12-12h256c6.8,0,12,5.6,12,12v292l-72,72H64c-6.8,0-12-5.2-12-12V16z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5F9FF"
    },
    d: "M332,122.4L187.2,376l0,0h-71.6L326.8,6c3.2,2.4,5.2,6,5.2,10V122.4L332,122.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5F9FF"
    },
    d: "M300.8,4L88.4,376H67.2L279.6,4H300.8L300.8,4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5F9FF"
    },
    d: "M56.4,376h-5.2L263.6,4h5.2L56.4,376z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B1E5D3"
    },
    d: "M96,60c0-4.4,3.6-8,8-8h192c4.4,0,8,3.6,8,8v108c0,4.4-3.6,8-8,8H104c-4.4,0-8-3.6-8-8V60L96,60z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A1E9FD"
    },
    d: "M272,328l8-8h40l-48,48V328z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#64BCE0"
    },
    d: "M56,16L56,16v352c0,4.4,3.6,8,8,8h184c6.8,0,16.8-4.4,21.6-8.8l49.2-49.2c4.8-4.8,8.8-14.8,8.8-21.6 V16c0-4.4-3.6-8-8-8H64C59.6,8,56,11.6,56,16L56,16z M48,16c0-8.8,7.2-16,16-16h256c8.8,0,16,7.2,16,16v280.4 c0,8.8-5.2,21.2-11.2,27.2l-49.2,49.2c-6.4,6.4-18.4,11.2-27.2,11.2H64c-8.8,0-16-7.2-16-16V16L48,16z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 44,
    style: {
      fill: "#F2FFF3"
    },
    width: 200,
    height: 116
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#64BCE0"
    },
    d: "M253.6,383.2c3.6-1.2,3.6-1.2,4.8-2c10-3.6,17.6-14.8,17.6-25.2v-24c0-4.4,3.6-8,8-8h24 c10.4,0,21.6-7.6,25.6-17.6l2-5.6l-7.6-2.4l-2,5.6c-2.8,6.4-10.8,12-18,12h-24c-8.8,0-16,7.2-16,16v24c0,7.2-5.6,15.2-12.4,18 c-1.2,0.4-1.2,0.4-4.8,2c-2,0.8-2,0.8-3.6,1.2C247.2,376.8,251.6,384,253.6,383.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FCD964"
    },
    cx: 120,
    cy: 80,
    r: 12
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D08B"
    },
    d: "M246.4,120.4c2.4-4,6-3.6,8,0L280,164h-42h-72.8H132h-20l8-13.2c2.4-3.6,6-3.6,8.4,0l3.2,5.2 l14.8-25.2c2.4-4,6-4,8,0l10,17.2L202,80c2-4,5.6-4,7.6,0l28.8,53.2L246.4,120.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#64BCE0"
    },
    d: "M90,192h120c1.2,0,2,0.8,2,2v4c0,1.2-0.8,2-2,2H90c-1.2,0-2-0.8-2-2v-4C88,192.8,88.8,192,90,192z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#64BCE0"
    },
    d: "M90,208h188c1.2,0,2,0.8,2,2v4c0,1.2-0.8,2-2,2H90c-1.2,0-2-0.8-2-2v-4C88,208.8,88.8,208,90,208z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#64BCE0"
    },
    d: "M90,224h156c1.2,0,2,0.8,2,2v4c0,1.2-0.8,2-2,2H90c-1.2,0-2-0.8-2-2v-4C88,224.8,88.8,224,90,224z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#64BCE0"
    },
    d: "M90,256h156c1.2,0,2,0.8,2,2v4c0,1.2-0.8,2-2,2H90c-1.2,0-2-0.8-2-2v-4C88,256.8,88.8,256,90,256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#64BCE0"
    },
    d: "M90,272h36c1.2,0,2,0.8,2,2v4c0,1.2-0.8,2-2,2H90c-1.2,0-2-0.8-2-2v-4C88,272.8,88.8,272,90,272z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#68BD6C"
    },
    d: "M92,48L92,48v108c0,2.4,1.6,4,4,4h192c2.4,0,4-1.6,4-4V48c0-2.4-1.6-4-4-4H96C94,44,92,45.6,92,48 L92,48z M88,48c0-4.4,3.6-8,8-8h192c4.4,0,8,3.6,8,8v108c0,4.4-3.6,8-8,8H96c-4.4,0-8-3.6-8-8V48L88,48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#68BD6C"
    },
    d: "M275.2,164l-24.4-41.6c-0.8-1.2-0.4-1.2-1.2,0l0,0l-7.6,12.8c-1.6,2.8-5.6,2.4-6.8,0L206.4,82 c-0.8-1.2,0-1.2-0.8,0L168,150c-1.6,2.8-5.2,2.8-6.8,0l-10-17.2c-0.8-1.2-0.4-1.2-1.2,0L135.2,158c-1.6,2.8-5.2,2.8-6.8,0l-3.2-5.2 c-0.8-1.2-0.8-1.2-1.6,0l-6.8,11.2h-2.4l-1.2-2l1.2-2h17.2h33.2h72.8h39.6l1.2,2l-0.8,2H275.2L275.2,164z M238.4,133.2l7.6-12.8 c2.4-4,6-3.6,8,0l26,43.6h-42h-72.8H132h-20l8-13.2c2.4-3.6,6-3.6,8.4,0l3.2,5.2l14.8-25.2c2.4-4,6-4,8,0l10,17.2L202,80 c2-4,5.6-4,7.6,0L238.4,133.2z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E9C54D"
    },
    d: "M120,88L120,88c4.4,0,8-3.6,8-8s-3.6-8-8-8s-8,3.6-8,8S115.6,88,120,88L120,88z M120,92L120,92 c-6.8,0-12-5.2-12-12s5.2-12,12-12s12,5.2,12,12S126.8,92,120,92L120,92z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentIcon);
export default __webpack_public_path__ + "static/media/document-icon.396611094f81ae2c8a71504493e6a554.svg";
export { ForwardRef as ReactComponent };